import type { SimulationSummaryTO } from '@control-center/control-center-client-public-domain-simulation-ts';
import { managementApi } from 'features/domain-simulation/apiClient';
import { useCallback, useEffect, useRef, useState } from 'react';

const useListDomainSimulations = (pollingIntervalMs?: number) => {
    const [simulations, setSimulations] = useState<SimulationSummaryTO[] | undefined>(undefined);
    const [isLoading, setIsLoading] = useState(false);
    const [isError, setIsError] = useState(false);
    const fetchRef = useRef<() => void>();

    useEffect(() => {
        let cancelled = false;

        const fetch = async () => {
            setIsLoading(true);
            try {
                const { data } = await managementApi.listSimulations();
                if (!cancelled) {
                    setIsError(false);
                    setSimulations(data);
                }
            } catch (error) {
                console.error(error);
                if (!cancelled) setIsError(true);
            } finally {
                if (!cancelled) setIsLoading(false);
            }
        };

        fetchRef.current = fetch;
        fetch();

        if (!pollingIntervalMs)
            return () => {
                cancelled = true;
            };
        const interval = setInterval(fetch, pollingIntervalMs);
        return () => {
            cancelled = true;
            clearInterval(interval);
        };
    }, [pollingIntervalMs]);

    const refresh = useCallback(() => fetchRef.current?.(), []);

    return { simulations, isLoading, isError, refresh };
};

export default useListDomainSimulations;
